export const timing = {
  /**
   * The duration (ms) for quick animations.
   */
  quick: 300
}
